import React from 'react';

export default React.createContext({
  checkPermissions: () => {},
  flushPermissions: () => {}
});
